import http from "@/http";
// ### 根据景区id获取门票
// https://zs.xzu.ink/api/ticket/list
export const getTicketList = {
  p: "/api/ticket/list",
  r: data => {
    return http({
      url: "/api/ticket/list",
      method: "post",
      data
    });
  }
};
//### 获取详情
// https://zs.xzu.ink/api/ticket/details/1080
export const getTicketInfo = {
  p: "/api/ticket/details",
  r: data => {
    return http({
      url: "/api/ticket/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加门票
// https://zs.xzu.ink/api/ticket/add
export const addTicket = {
  p: "/api/ticket/add",
  r: data => {
    return http({
      url: "/api/ticket/add",
      method: "post",
      data
    });
  }
};
// ### 修改门票
// https://zs.xzu.ink/api/ticket/edit
export const editTicket = {
  p: "/api/ticket/edit",
  r: data => {
    return http({
      url: "/api/ticket/edit",
      method: "post",
      data
    });
  }
};
// ### 删除
// https://zs.xzu.ink/api/ticket/delete
export const deleteTicket = {
  p: "/api/ticket/delete",
  r: data => {
    return http({
      url: "/api/ticket/delete",
      method: "post",
      data
    });
  }
};
// ### 设置门票销售策列
// https://zs.xzu.ink/api/ticket/pricing
export const setTicketPricing = {
  p: "/api/ticket/pricing",
  r: data => {
    return http({
      url: "/api/ticket/pricing",
      method: "post",
      data
    });
  }
};
// ### 获取设置的门票策列
// https://zs.xzu.ink/api/ticket/get_pricing
export const getTicketPricingList = {
  p: "/api/ticket/get_pricing",
  r: data => {
    return http({
      url: "/api/ticket/get_pricing",
      method: "post",
      data
    });
  }
};
// ### 同步计花
// https://zs.xzu.ink/api/scenic/sync_plan/{scenic_id}   post
export const syncPlan = {
  p: "api/scenic/sync_plan",
  r: data => {
    return http({
      url: "api/scenic/sync_plan",
      method: "post",
      data
    });
  }
};
